import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.page.html',
  styleUrls: ['./templates.page.scss'],
})
export class TemplatesPage implements OnInit {
  @Input() edit_template: any = null; // Pass in a template to edit directly
  @Input() allow_edit = true; // Set to false to disable editing and just show template content
  template = {
    title: '',
    body: '',
    is_update: false,
    guid: ''
  }

  templates: any = [];
  finished_loading = false;

  @ViewChild('bodyEditor') bodyEditor: any;
  private lastCursorIndex: number | null = null;


  constructor(private apiService: ApiService,public globalService: GlobalService,private modalController: ModalController) { }

  ngOnInit() {
    this.Get();
    // If an edit_template was passed in, load it - is_update follows whether it actually has a guid,
    // not just whether something was passed in, so a caller can preload title/body from an existing
    // template while still asking for a brand new one (e.g. manage-firm.page.ts's "Create From",
    // which passes guid: '' on purpose so Save creates a new template instead of overwriting the one
    // it was copied from).
    if (this.edit_template) {
      this.template = {
        title: this.edit_template.title || '',
        body: this.edit_template.body || '',
        is_update: !!this.edit_template.guid,
        guid: this.edit_template.guid || ''
      };
    }
  }

  OnEditorSelectionChanged(event: any) {
    if (event.range !== null) {
      this.lastCursorIndex = event.range.index;
    }
  }

  OnEditorContentChanged(event: any) {
    const range = event.editor?.getSelection();
    if (range !== null) {
      this.lastCursorIndex = range?.index ?? this.lastCursorIndex;
    }
  }

  AppendToBody(field: string) {
    const quill = this.bodyEditor?.quillEditor;
    if (quill) {
      const index = this.lastCursorIndex ?? quill.getLength();
      const charBefore = index > 0 ? quill.getText(index - 1, 1) : ' ';
      const charAfter = quill.getText(index, 1);
      const prefix = charBefore !== ' ' ? ' ' : '';
      const suffix = charAfter !== ' ' && charAfter !== '.' && charAfter !== '\n' && charAfter !== '' ? ' ' : '';
      const textToInsert = prefix + field + suffix;
      quill.insertText(index, textToInsert, 'user');
      const newIndex = index + textToInsert.length;
      quill.setSelection(newIndex, 0);
      this.lastCursorIndex = newIndex;
      this.template.body = quill.root.innerHTML;
    } else {
      this.template.body = (this.template.body || '') + field;
    }
  }

  async Get() {
    this.finished_loading = false;
    let data: any = await this.apiService.get('email_templates');
    this.templates = data.data;
    console.log(this.templates);
    this.finished_loading = true;

  }

  //Search through the template array to see if we have a match, if we do. go into edit mode
  async OnTemplateTitleChange(title) {
    this.finished_loading = false;
    var selected_template = this.templates.find(template => template.title.toLowerCase() == title.toLowerCase());
    if(selected_template) {
      this.template.is_update = true;
      this.template.body = selected_template.body;
      this.template.guid = selected_template.guid;
    } 
    else {
      this.template.is_update = false;

    }
    this.finished_loading = true;

    console.log(this.template.is_update);

  }

  async CreateTemplate(){
    let data: any = await this.apiService.post('email_templates',this.template);
    this.globalService.presentToastMessage(data.message,data.success);
    if(data.success) this.templates.push(data.data[0]);
    this.template = {
      title: '',
      body: '',
      is_update: false,
      guid: ''
    }
  }

  async UpdateTemplate() {
    let data: any = await this.apiService.put(`email_templates/${this.template.guid}`,this.template);
    this.globalService.presentToastMessage(data.message,data.success);
    this.Get();
  }

  async DeleteTemplate() {
    let data: any = await this.apiService.delete(`email_templates/${this.template.guid}`,null);
    this.globalService.presentToastMessage(data.message,data.success);
    this.template = {
      title: '',
      body: '',
      is_update: false,
      guid: ''
    }
    this.Get();
  }

  async Close() {
    this.modalController.dismiss();
  }

  error_message = '';
  has_error = false;

  ngDoCheck() {
    this.CheckIfFormIsValid();
  }

  CheckIfFormIsValid() {
    this.error_message = '';
    let has_error = false;
    const messages: string[] = [];


    // Company name required
    // Template title required
    if (this.template.title.trim() === '') {
      messages.push('Template name is required.');
      has_error = true;
    }

    // Write to string for tooltip or display
    this.error_message = messages.join('<br>');
    this.has_error = has_error;
  }


}
